import React from "react";
import ErrorField from "./error";
import Big from "big.js";
import { CurrencyField } from "components/support";
import { observer } from "mobx-react";

const RestockCountField = ({ errors, row, onChange }) => {
  const { restock_count } = row;
  let parsedRestockCount = "0.00";
  if (restock_count && restock_count.length !== 0) {
    parsedRestockCount = Big(restock_count).toFixed(2);
  }
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.restock_count;

  return (
    <div>
      <CurrencyField
        value={parsedRestockCount}
        onChange={(_, value) =>
          onChange(Big(value.replace(/\D/g, "")).div(100))
        }
        fullWidth
        unit=""
      />
      {hasErrors && <ErrorField error={foundErrors.errors.restock_count} />}
    </div>
  );
};

export default observer(RestockCountField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/restock-count.js